import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions from '../../../common/flex-options/flex-options.esm.js';
import fontOptions from '../../../common/font-options/font-options.esm.js';

var labelTV = getTvObject({
  base: [].concat(_toConsumableArray(flexOptions.base), ['text-size-inherit', 'text-inherit']),
  variants: _objectSpread2(_objectSpread2({}, fontOptions), flexOptions.variants)
});
var base = tv(labelTV);
var labelStyles = {
  base: base
};

export { labelStyles, labelTV };
//# sourceMappingURL=label.styles.esm.js.map
